import React from 'react';
import Logo from '../../assets/seclogoanimado.gif'
import PoweredBy from '../../assets/powered by@2x.png'
import { BackButton, BackDiv, ButtonDiv, Container, DivFlexCenter, DivLogo, DivTextAlignCenter, ImageHeader, ImagePaymentType, LabelPaymentType, Title } from '../../styles/styles';
import Pix from '../../assets/pix.png';
import Cartao from '../../assets/cartao.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

function Pay() {

    let goToLastPage = () => {
        window.history.go(-1);
    }

    let goToPayCard = () => {
        window.location.href = '/PayCard';
    }

    let goToPayPix = () => {
        window.location.href = '/PayPix';
    }

    return (
        <>
            <BackDiv className='mt-2'>
                <BackButton onClick={goToLastPage}  type='button' className='btn btn-icon-only'>
                    <span style={{ color: '#fff' }}><FontAwesomeIcon size='2x' icon={faChevronLeft as IconProp} /></span>
                </BackButton>
            </BackDiv>

            <DivFlexCenter>
                <Container className='mt-2'>
                    <DivTextAlignCenter>

                        <ImageHeader src={Logo} />

                        <hr />

                        <Title style={{ fontFamily: 'Lemon Milk', color: '#CE6B00' }}>
                            SELECIONE A OPÇÃO DE PAGAMENTO
                        </Title>

                        <ButtonDiv onClick={goToPayCard}>
                            <ImagePaymentType src={Cartao} />
                            <LabelPaymentType>
                                CARTÃO
                            </LabelPaymentType>
                        </ButtonDiv>

                        <ButtonDiv onClick={goToPayPix}>
                            <ImagePaymentType src={Pix} />
                            <LabelPaymentType>
                                PIX
                            </LabelPaymentType>
                        </ButtonDiv>

                        <hr/>

                        <img src={PoweredBy} />
                    </DivTextAlignCenter>
                </Container>
            </DivFlexCenter>
        </>
    );
}

export default Pay;